<template>
  <div class="content_wrap">
    <div class="inside_wrap">
      <CallHelpTel />
      <HomeSearch />
      <HotCountry />
      <News />
      <a-modal
        v-model:visible="open"
        :footer="null"
        :width="focusNew.type === 'text' ? 600 : 'fit-content'"
        :bodyStyle="{ padding: focusNew.type === 'text' ? '24px' : '0' }"
      >
        <a
          v-if="focusNew.type === 'image'"
          :href="focusNew.url ?? ''"
          target="_blank"
          :title="focusNew.title"
          @click="handleClick"
        >
          <img :src="focusNew.filePath" :alt="focusNew.title" />
          <!-- <img src="../img/Banner.png" /> -->
        </a>
        <div v-else-if="focusNew.type === 'text'" class="focus_new_text">
          <div>{{ focusNew.content }}</div>
        </div>
      </a-modal>
    </div>
    <LatestNews :International="International" type="最新消息" />
    <More justify="News" type="最新消息" />
    <hr class="hr" />
    <Employment />
    <hr class="hr" />
    <Guide />
    <hr class="hr" />
    <ReturningArea />
    <More justify="Return_employment" type="海外返國資訊" />
    <GoToTop />
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import HomeSearch from "../components/Home/HomeSearch.vue";
import HotCountry from "../components/Home/HotCountry.vue";
import News from "../components/Home/News.vue";
import LatestNews from "../components/Home/LatestNews.vue";
import More from "../components/Home/More.vue";
import Employment from "../components/Home/Employment.vue";
import Guide from "../components/Home/Guide.vue";
import ReturningArea from "../components/Home/ReturningArea.vue";
import { apiNews, apiFocusNew, apiFocusNewCount } from "@/api/api.js";
import { fakeImg } from "@/fake_data.js";

export default defineComponent({
  name: "Home",
  components: {
    CallHelpTel,
    HomeSearch,
    HotCountry,
    News,
    LatestNews,
    Employment,
    Guide,
    ReturningArea,
    More,
  },

  setup() {
    const International = reactive([]);
    const open = ref(false);

    let focusNew = reactive({
      filePath: "",
      url: "",
      title: "",
      content: "",
      type: "",
    });

    apiFocusNew().then((res) => {
      var data = res.data;
      const hasImageContent =
        data.type === "image" && data.filePath != "" && data.filePath != null;
      const hasTextContent =
        data.type === "text" && data.content != "" && data.content != null;

      if (hasImageContent || hasTextContent) {
        open.value = true;
        focusNew.filePath = data.filePath;
        focusNew.url = data.url;
        focusNew.title = data.title;
        focusNew.content = data.content;
        focusNew.type = data.type;
      }
    });

    apiNews({
      keyword: "",
      page: 1,
    })
      .then((res) => {
        res.data.newsDatas.forEach((message) => {
          if (!message.imageFiles.length)
            message.imageFiles.push({ fileId: "000", filePath: fakeImg });
          International.push(message);
        });
      })
      .catch((err) => {
        console.log("返國最新資訊失敗", err);
      });

    const handleClick = () => {
      apiFocusNewCount();
    };
    return { International, open, focusNew, handleClick };
  },
});
</script>

<style lang="scss">
.inside_wrap {
  background: url(../img/help_tel.svg) no-repeat top/100%;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  letter-spacing: 1.2px;
}
.main,
#header,
#footer {
  width: 100%;
  margin: 0 auto;
}

#nav {
  a {
    font-weight: bold;
    color: #024d73;
    &.router-link-exact-active {
      color: #555;
    }
  }
}
.content_wrap {
  margin: 0 20px;
}

.focus_new_text {
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
